// extracted by mini-css-extract-plugin
export default {"TinAttentionDialog":"styles_TinAttentionDialog__2P7KI","questionMessage":"styles_questionMessage__VbYql"};